import type { ReactElement } from 'react';
import { SitePageShell } from '@/shared/ui';
import { MyDesignGrid } from '@/widgets/my-design-grid';
import { MyPageHeader } from '@/widgets/my-page-header';
import { MyPageNav } from '@/widgets/my-page-nav';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

/** 내 디자인(/my/designs) — 저장한 디자인 카드 격자. 큰 "My Page" 머리 아래 왼쪽(좁은 화면은 위) 메뉴와 본문을 놓는다. */
export const MyDesignsPage = (): ReactElement => (
  <SitePageShell header={<SiteHeader />} footer={<SiteFooter />} className="pt-12 sm:pt-16">
    <MyPageHeader />
    <div className="mt-8 grid gap-10 sm:mt-12 lg:grid-cols-[13rem_minmax(0,1fr)] lg:gap-16 xl:grid-cols-[15rem_minmax(0,1fr)] xl:gap-20">
      <MyPageNav activeId="designs" />
      <MyDesignGrid />
    </div>
  </SitePageShell>
);
